import { ColorSchemeContext } from "@/context/ColorSchemeContext";
import { generateNewColors } from "@/utils/color-scheme-utils";
import { ColorScheme } from "@stackje/common/colorScheme";
import type { CommonColor } from "@stackje/common/config";
import { useCallback, useContext, useState } from "react";

export function useColorSchemeShuffler<Colors extends CommonColor>(
  initialColors: Colors,
  onColorsChange?: (colors: Colors) => void
) {
  const [colors, setColors] = useState<Colors>(initialColors);
  const { colorSchemeId, customColors } = useContext(ColorSchemeContext)

  // Use custom colors if available, otherwise use predefined scheme colors
  const currentSchemeColors = colorSchemeId === "custom" && customColors
    ? customColors
    : ColorScheme[colorSchemeId];

  const shuffleColors = useCallback(() => {
    const nextColors = generateNewColors(initialColors, currentSchemeColors);
    setColors(nextColors as Colors);
    onColorsChange?.(nextColors as Colors);
  }, [setColors, onColorsChange, initialColors, currentSchemeColors])

  return {
    colors,
    setColors,
    shuffleColors,
  };
}
